import { useQuery } from "react-query";
import { getMedicalHistory } from "api/customers";

const useGetMedicalHistory = (clientId: number | null) => {
  const { data, isLoading, isError, refetch } = useQuery(
    ["getMedicalHistory", clientId],
    () => getMedicalHistory(clientId!),
    {
      enabled: !!clientId,
      refetchOnWindowFocus: false,
    }
  );

  return {
    medicalHistory: data?.data || null,
    isMedicalHistoryLoading: isLoading,
    isMedicalHistoryError: isError,
    refetchMedicalHistory: refetch,
  };
};

export default useGetMedicalHistory;
